import React from 'react';
import { formatNumber } from './format';
import { MembersAnalytics } from './membersAnalyticsLogic';
import ProgressRing from './ProgressRing';

type FunnelItem = MembersAnalytics['funnel'][number];

const FUNNEL_LABEL_ICONS: Record<string, string> = {
  'Registered members': 'resources/images/SealCheck.svg',
  'Onboarded members': 'resources/images/DeviceMobileSpeaker.svg',
  'Joined team': 'resources/images/UsersThree.svg',
  'Studio members': 'resources/images/UsersThree.svg',
};

interface IProps {
  item: FunnelItem;
}

export default function SummaryMetricCard(props: IProps) {
  const { item } = props;
  const className = [
    'members-analytics-funnel-card',
    item.showPercent ? '' : 'members-analytics-funnel-card-count',
    item.label === 'Studio members' ? 'members-analytics-funnel-card-highlight' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={className}>
      {item.showPercent ? (
        <ProgressRing percent={item.percent} dark>{item.percent}%</ProgressRing>
      ) : (
        <div className='members-analytics-funnel-count'>{formatNumber(item.count)}</div>
      )}
      {item.showPercent && (
        <div className='members-analytics-funnel-count'>{formatNumber(item.count)}</div>
      )}
      <div className='members-analytics-funnel-label'>
        {FUNNEL_LABEL_ICONS[item.label] && (
          <img
            className='members-analytics-funnel-label-icon'
            src={FUNNEL_LABEL_ICONS[item.label]}
            alt=''
          />
        )}
        <span>{item.label}</span>
      </div>
    </div>
  );
}
